import React from "react";
import { Link } from "react-router-dom";
import { Star, Clock, Phone, Navigation, Zap, Award } from "lucide-react";
import { apiFetch } from "@/lib/api";

export function trackVet(vetId, event) {
  apiFetch(`/vets/${vetId}/track`, { method: "POST", body: JSON.stringify({ event }) }, false).catch(() => {});
}

export function mapsUrl(vet) {
  const q = encodeURIComponent(`${vet.name} ${vet.address} ${vet.city}`);
  return `https://www.google.com/maps/search/?api=1&query=${q}`;
}

export default function VetCard({ vet }) {
  return (
    <Link
      to={`/app/vets/${vet.id}`}
      data-testid={`vet-card-${vet.id}`}
      className={`block rounded-3xl overflow-hidden border transition-shadow hover:shadow-md ${
        vet.is_featured ? "border-[#E86A45] bg-[#FFF7F3]" : "border-[#E8E3DA] bg-white"
      }`}
    >
      <div className="flex gap-3 p-3">
        <div className="h-24 w-24 shrink-0 rounded-2xl overflow-hidden bg-[#F2EFE9]">
          <img src={vet.photo_url} alt={vet.name} className="h-full w-full object-cover" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            {vet.is_featured && (
              <span className="inline-flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#E86A45] text-white">
                <Award size={11} /> Featured
              </span>
            )}
            {vet.is_emergency_24_7 && (
              <span className="inline-flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-wide px-2 py-0.5 rounded-full bg-[#FDECEB] text-[#D9534F]">
                <Zap size={11} /> 24/7
              </span>
            )}
          </div>
          <p className="font-extrabold truncate mt-1">{vet.name}</p>
          <div className="flex items-center gap-2 text-sm text-[#4A4746] mt-0.5">
            <span className="flex items-center gap-1"><Star size={14} color="#F3B05A" fill="#F3B05A" /> {vet.rating}</span>
            <span>·</span>
            <span>{vet.distance_km?.toFixed?.(1) ?? vet.distance_km} km</span>
          </div>
          <p className="text-sm text-[#9A938B] truncate mt-0.5 flex items-center gap-1">
            <Clock size={13} /> {vet.hours}
          </p>
        </div>
      </div>
    </Link>
  );
}

export { Phone, Navigation };
